import { create } from "zustand";
import { produce } from "immer";
import { getImpersonationSession } from "../../services/auth";

const defaultData = {
  open: false,
  loading: false,
  starting: false,
  stores: [],
  users: [],
  storeFilter: "",
  userFilter: "",
  selectedStore: false,
  selectedUser: false,
  session: getImpersonationSession() || false,
};

export const useImpersonation = create((set) => ({
  data: defaultData,
  actions: {
    setOpen: (open) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.open = open;
        })
      ),
    setLoading: (loading) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.loading = loading;
        })
      ),
    setStarting: (starting) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.starting = starting;
        })
      ),
    setStores: (stores = []) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.stores = stores;
        })
      ),
    setUsers: (users = []) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.users = users;
        })
      ),
    setStoreFilter: (storeFilter) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.storeFilter = storeFilter;
        })
      ),
    setUserFilter: (userFilter) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.userFilter = userFilter;
        })
      ),
    selectStore: (selectedStore = false) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.selectedStore = selectedStore;
          draft.data.selectedUser = false;
          draft.data.users = [];
          draft.data.userFilter = "";
        })
      ),
    selectUser: (selectedUser = false) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.selectedUser = selectedUser;
        })
      ),
    syncSession: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.session = getImpersonationSession() || false;
        })
      ),
    clearFlow: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.open = false;
          draft.data.loading = false;
          draft.data.starting = false;
          draft.data.stores = [];
          draft.data.users = [];
          draft.data.storeFilter = "";
          draft.data.userFilter = "";
          draft.data.selectedStore = false;
          draft.data.selectedUser = false;
          draft.data.session = getImpersonationSession() || false;
        })
      ),
  },
}));
